export const urlEncode = (s) => encodeURIComponent(s).replace(/%20/gi, '+');
